import { useRouter, useSearchParams } from 'next/navigation';
import React, { FC, useEffect, useRef, useState } from 'react';

import Icon from './Icon';

export type SearchInputProps = {
  className?: string;
  placeholder?: string;
  defaultValue?: string;
};

const SearchInput: FC<SearchInputProps> = (props) => {
  const { className, placeholder, defaultValue } = props;
  const inputRef = React.useRef<HTMLInputElement>(null);
  const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);
  const router = useRouter();
  const searchParams = useSearchParams();
  const [value, setValue] = useState(defaultValue || '');
  const [searchKey, setSearchKey] = useState<string | undefined>();

  useEffect(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setSearchKey(value);
    }, 300);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [value]);

  useEffect(() => {
    setValue(defaultValue || '');
  }, [defaultValue]);

  const handleSearch = () => {
    // Preserve existing filters when searching
    const newParams = new URLSearchParams(searchParams.toString());
    if (value.trim()) {
      newParams.set('search', value.trim());
    } else {
      newParams.delete('search');
    }
    router.push(`/search?${newParams.toString()}`);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleSearch();
  };

  return (
    <div className={'flex flex-row items-center justify-center bg-white px-4 py-3 md:py-5 w-full '.concat(className || '')}>
      <form onSubmit={onSubmit} className="w-full flex flex-row items-center justify-between gap-2">
        <div className="flex-1">
          <input ref={inputRef} value={value} onChange={handleChange} type="text" name={'search'} placeholder={placeholder || 'Buscar...'} className={'outline-0 bg-transparent w-full'} />
        </div>
        <button type="submit" className="bg-transparent text-secondary-900 border-0 outline-0 p-0 m-0 cursor-pointer hover:opacity-50" aria-label="Buscar">
          <Icon name="search" size={23} />
        </button>
      </form>
    </div>
  );
};

export default SearchInput;
